import { CREATE_SUPPLIER, GET_SUPPLIERS, SET_SUPPLIERS } from './actionTypes'

export function createSupplierSaga(data) {
  return {
    type: CREATE_SUPPLIER,
    data,
  }
}

export function setSuppliers(data) {
  return {
    type: SET_SUPPLIERS,
    data,
  }
}

export function getSuppliersSaga(data) {
  return {
    type: GET_SUPPLIERS,
    data,
  }
}
